"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var escape_1 = __importDefault(require("licia/escape"));
var toStr_1 = __importDefault(require("licia/toStr"));
var contain_1 = __importDefault(require("licia/contain"));
var startWith_1 = __importDefault(require("licia/startWith"));
var escapeJsStr_1 = __importDefault(require("licia/escapeJsStr"));
var each_1 = __importDefault(require("licia/each"));
var endWith_1 = __importDefault(require("licia/endWith"));
var isEmpty_1 = __importDefault(require("licia/isEmpty"));
var util_1 = require("./util");
var util_2 = require("../share/util");
var c = (0, util_2.classPrefix)('console');
function getAbstract(obj, _a) {
    var _b = _a === void 0 ? {} : _a, topObj = _b.topObj, _c = _b.level, level = _c === void 0 ? 0 : _c, _d = _b.getterVal, getterVal = _d === void 0 ? false : _d, _e = _b.unenumerable, unenumerable = _e === void 0 ? true : _e;
    var json = '';
    var type = '';
    var keyNum = 5;
    var parts = [];
    var names = [];
    var objEllipsis = '';
    var circular = false;
    var i;
    topObj = topObj || obj;
    var passOpts = { getterVal: getterVal, unenumerable: unenumerable, level: level + 1 };
    var doStringify = level === 0;
    var keyWrapper = "<span class=\"".concat(c('key'), "\">");
    var numWrapper = "<span class=\"".concat(c('number'), "\">");
    var nullWrapper = "<span class=\"".concat(c('null'), "\">");
    var strWrapper = "<span class=\"".concat(c('string'), "\">");
    var boolWrapper = "<span class=\"".concat(c('boolean'), "\">");
    var specialWrapper = "<span class=\"".concat(c('special'), "\">");
    var strEscape = function (str) {
        return (0, escape_1.default)(str)
            .replace(/\\n/g, '↵')
            .replace(/\\f|\\r|\\t/g, '')
            .replace(/\\/g, '');
    };
    var wrapperEnd = '</span>';
    var wrapKey = function (key) { return keyWrapper + strEscape(key) + wrapperEnd; };
    var wrapNum = function (num) { return numWrapper + num + wrapperEnd; };
    var wrapRegExp = function (str) { return strWrapper + str + wrapperEnd; };
    var wrapBool = function (bool) { return boolWrapper + bool + wrapperEnd; };
    var wrapNull = function (str) { return nullWrapper + str + wrapperEnd; };
    function wrapStr(str) {
        str = (0, toStr_1.default)(str);
        if ((0, contain_1.default)(SPECIAL_VAL, str) || (0, startWith_1.default)(str, 'Array[')) {
            return specialWrapper + strEscape(str) + wrapperEnd;
        }
        return strWrapper + strEscape("\"".concat(str, "\"")) + wrapperEnd;
    }
    function objIteratee(name) {
        if (i > keyNum) {
            objEllipsis = ', …';
            return;
        }
        var key = wrapKey(escapeJsonStr(name));
        if (!getterVal) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, name);
            if (descriptor && descriptor.get) {
                parts.push("".concat(key, ": ").concat(wrapStr('(...)')));
                i++;
                return;
            }
        }
        parts.push("".concat(key, ": ").concat(getAbstract(topObj[name], passOpts)));
        i++;
    }
    try {
        type = {}.toString.call(obj);
    }
    catch (e) {
        type = '[object Object]';
    }
    var isStr = type == '[object String]';
    var isArr = type == '[object Array]';
    var isObj = type == '[object Object]';
    var isNum = type == '[object Number]';
    var isRegExp = type == '[object RegExp]';
    var isSymbol = type == '[object Symbol]';
    var isFn = type == '[object Function]';
    var isBool = type == '[object Boolean]';
    if (circular) {
        json = wrapStr('[circular]');
    }
    else if (isStr) {
        json = wrapStr(escapeJsonStr(obj));
    }
    else if (isRegExp) {
        json = wrapRegExp(escapeJsonStr(obj.toString()));
    }
    else if (isFn) {
        json = wrapStr('ƒ');
    }
    else if (isArr) {
        if (doStringify) {
            json = '[';
            var len = obj.length;
            var arrEllipsis = '';
            if (len > 100) {
                len = 100;
                arrEllipsis = ', …';
            }
            for (var i_1 = 0; i_1 < len; i_1++) {
                parts.push("".concat(getAbstract(obj[i_1], passOpts)));
            }
            json += parts.join(', ') + arrEllipsis + ']';
        }
        else {
            json = "Array(".concat(obj.length, ")");
        }
    }
    else if (isObj) {
        if (canBeProto(obj)) {
            obj = Object.getPrototypeOf(obj);
        }
        names = unenumerable ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        if (doStringify) {
            i = 1;
            json = '{';
            (0, each_1.default)(names, objIteratee);
            json += parts.join(', ') + objEllipsis + '}';
        }
        else {
            json = (0, util_1.getObjType)(obj);
            if (json === 'Object')
                json = '{…}';
        }
    }
    else if (isNum) {
        json = obj + '';
        if ((0, endWith_1.default)(json, 'Infinity') || json === 'NaN') {
            json = "\"".concat(json, "\"");
        }
        else {
            json = wrapNum(json);
        }
    }
    else if (isBool) {
        json = wrapBool(obj ? 'true' : 'false');
    }
    else if (obj === null) {
        json = wrapNull('null');
    }
    else if (isSymbol) {
        json = wrapStr('Symbol');
    }
    else if (obj === undefined) {
        json = wrapStr('undefined');
    }
    else {
        try {
            if (canBeProto(obj)) {
                obj = Object.getPrototypeOf(obj);
            }
            if (doStringify) {
                i = 1;
                json = '{';
                names = unenumerable
                    ? Object.getOwnPropertyNames(obj)
                    : Object.keys(obj);
                (0, each_1.default)(names, objIteratee);
                json += parts.join(', ') + objEllipsis + '}';
            }
            else {
                json = (0, util_1.getObjType)(obj);
                if (json === 'Object')
                    json = '{…}';
            }
        }
        catch (e) {
            json = wrapStr(obj);
        }
    }
    return json;
}
exports.default = getAbstract;
var SPECIAL_VAL = ['(...)', 'undefined', 'Symbol', 'Object', 'ƒ'];
function canBeProto(obj) {
    var emptyObj = (0, isEmpty_1.default)(Object.getOwnPropertyNames(obj));
    var proto = Object.getPrototypeOf(obj);
    return emptyObj && proto && proto !== Object.prototype;
}
function escapeJsonStr(str) {
    return (0, escapeJsStr_1.default)(str).replace(/\\'/g, "'").replace(/\t/g, '\\t');
}
